import { createState } from '@helpers/createState'
import { combineReducers } from 'redux'

import * as TYPES from '../constants/actionTypes'
import * as STATE from '../constants/state'

const reducer = combineReducers({
  [STATE.GENERAL_APPLICATION]: createState(TYPES.GENERAL_APPLICATION),
  [STATE.GENERAL_APPLICATION_LIST]: createState(TYPES.GENERAL_APPLICATION_LIST),
  [STATE.GENERAL_APPLICATION_ALL]: createState(TYPES.GENERAL_APPLICATION_ALL),
  [STATE.GENERAL_APPLICATION_TYPES]: createState(TYPES.GENERAL_APPLICATION_TYPES),
  [STATE.GENERAL_APPLICATION_STATUS]: createState(TYPES.GENERAL_APPLICATION_STATUS),
  [STATE.GENERAL_APPLICATION_FIELD_BATCH]: createState(TYPES.GENERAL_APPLICATION_FIELD_BATCH),
  [STATE.GENERAL_APPLICATION_CATEGORY]: createState(TYPES.GENERAL_APPLICATION_CATEGORY),
  [STATE.GENERAL_APPLICATION_CATEGORY_LIST]: createState(TYPES.GENERAL_APPLICATION_CATEGORY_LIST),
  [STATE.GENERAL_APPLICATION_CATEGORY_ALL]: createState(TYPES.GENERAL_APPLICATION_CATEGORY_ALL),
  [STATE.GENERAL_APPLICATION_REQUEST_ALL]: createState(TYPES.GENERAL_APPLICATION_REQUEST_ALL),
  [STATE.GENERAL_APPLICATION_REQUEST_EDIT]: createState(TYPES.GENERAL_APPLICATION_REQUEST_EDIT),
  [STATE.GENERAL_APPLICATION_REQUEST_UPDATE]: createState(TYPES.GENERAL_APPLICATION_REQUEST_UPDATE),
})

export const GENERAL_ADMISSION = STATE.GLOBAL_STATE

export default reducer
